import React, { useEffect, useState, useRef } from "react";
import { useListFilters } from "../../helper/useListFilters";
import ResponsiveDrawer from "../../component/sidebar/sidebar.component";
import { FontFamily } from "../../component/theme/fontFamily";
import { fontWeight } from "../../component/theme/fontWeight";
import { fontSize } from "../../component/theme/fontSize";
import {
  Box,
  Grid,
  IconButton,
  Switch,
  Tooltip,
  Typography,
  styled,
} from "@mui/material";
import { ThemeColor } from "../../component/theme/color";
import CustomDataTable from "../../component/datatable/DataTable";
import OutlineCustomButton from "../../component/button/outlineButton";
import { useDispatch, useSelector } from "react-redux";
import {
  GetProgramAction,
  GetUniversityAction,
} from "../../Redux/action/SettingAction";
import { showSnackbar } from "../../Redux/action/SnackbarAction";
import { useNavigate, useParams } from "react-router-dom";
import FilterComponent from "../../component/filterForTable/FilterComponent";
import { basicurl, token } from "../../Redux/ServiceUrl/url";
import axios from "axios";
import { GetDegreeAction } from "../../Redux/action/ApplicationAction";
import ConfirmationModal from "../../component/Modal/ConfirmationModal/ConfirmationModal";
import {
  DeleteProgAvailableService,
  EditProgAvailableService,
} from "../../Redux/service/SettingService";
import { Edit } from "@mui/icons-material";
import DeleteIcon from "@mui/icons-material/Delete";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const NoPaddingGridItem = styled(Grid)({
  paddingTop: "0px !important",
});

const selectOptions = [
  { value: 10, label: "Option 1" },
  { value: 20, label: "Option 2" },
  { value: 30, label: "Option 3" },
];
const ProgramlistPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { id } = useParams();

  const [Programlist, setProgramlist] = useState([]);

  const [isToggled, setIsToggled] = useState(false);

  const [table_load, setTable_load] = useState(false);

  const [isFilterOpen, setFilterOpen] = useState(false);

  const [Degreelist, setDegreelist] = useState([]);

  const [Universitylist, setUniversitylist] = useState([]);

  const [FilterProglist, setFilterProglist] = useState([]);

  const [confirmationopen, setConfirmationOpen] = useState(false);
  const [deleteconfirmationopen, setDeleteConfirmationOpen] = useState(false);

  const [changeBlockStatusOfOrg, setChangeBlockStatusOfOrg] = useState({});
  const [deleteId, setDeleteId] = useState();

  const UniversitylistState = useSelector(
    (state) => state.setting?.university?.data?.universities
  );

  const DegreelistState = useSelector(
    (state) => state.application?.degree?.data?.degrees
  );

  const ProgramlistState = useSelector(
    (state) => state.setting?.program?.data?.programs
  );

  useEffect(() => {
    let data = {
      page: 1,
      limit: 0,
    };
    dispatch(GetUniversityAction(data));
    dispatch(GetDegreeAction());
  }, []);

  useEffect(() => {
    setUniversitylist(
      UniversitylistState?.map(({ name, ...rest }) => ({
        title: name,
        ...rest,
      }))
    );

    setDegreelist(
      DegreelistState?.map(({ name, ...rest }) => ({
        title: name,
        ...rest,
      }))
    );
  }, [UniversitylistState, DegreelistState, ProgramlistState]);

  const fetchData = async (filters) => {
    let string = filters.map((data) => `${data.field}=${data.value}`);
    try {
      let response = await axios.get(
        basicurl + `/api/program/get-all-programs?${string.join("&")}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // const result = await response.json();
      console.log(response);

      setProgramlist(
        response?.data?.programs?.map(({ _id, ...rest }) => ({
          id: _id,
          ...rest,
        }))
      );
    } catch (error) {
      console.error("Error fetching filtered data:", error);
    }
  };

  /**
   * Reload the rows.
   *
   * Every action on this page reloads through here so that a filter which
   * is on screen stays applied. Applying a filter used `fetchData` while
   * every action afterwards used the plain redux action, so the table went
   * back to showing everything while the panel still said a filter was on.
   *
   * The filters live in component state, so leaving the page and coming
   * back starts clean with the full list.
   */
  /** False until the first redux sync, so mounting does not fetch twice. */
  const reduxSyncedOnce = useRef(false);

  const { activeFilters, getFilters, applyFilters } = useListFilters(
    (filters) => fetchData(filters),
    () => dispatch(GetProgramAction({ page: 1, limit: 0 }))
  );

  const reload = (data) => {
    // Read through the ref: some of the callers below are memoised with
    // empty deps, so a captured value would be frozen as "no filters".
    const applied = getFilters();
    if (applied.length > 0) {
      fetchData(applied);
      return;
    }
    dispatch(GetProgramAction(data));
  };

  const handleApplyFilters = applyFilters;

  const columns = [
    {
      field: "program",
      headerName: "Program name",
      width: 250,
    },
    {
      field: "university",
      headerName: "University name",
      width: 450,
      renderCell: (params) => {
        return (
          <div style={{ textDecoration: "underline" }}>
            {params.row.university.name}
          </div>
        );
      },
    },
    {
      field: "degree",
      headerName: "Degree name",
      width: 390,
      renderCell: (params) => {
        return <div>{params.row.degree.name}</div>;
      },
    },
    {
      field: "country",
      headerName: "Country",
      width: 290,
      renderCell: (params) => {
        return <div>{params.row.university.country}</div>;
      },
    },
    {
      field: "state",
      headerName: "State",
      width: 190,
      renderCell: (params) => {
        return <div>{params.row.university.state}</div>;
      },
    },
    {
      field: "city",
      headerName: "City",
      width: 190,
      renderCell: (params) => {
        return <div>{params.row.university.city}</div>;
      },
    },
    {
      field: "ContarctType",
      headerName: "Contract Type",
      width: 190,
      renderCell: (params) => {
        return <div>{params.row.university.contractType}</div>;
      },
    },
    {
      field: "delete",
      headerName: "",
      width: 100,
      renderCell: (params) => {
        const handleDeleteProg = () => {
          setDeleteId(params.row.id);
          setDeleteConfirmationOpen(true);
        };
        return (
          <>
            {/* {window.sessionStorage.getItem("user_role_type") === "admin" && ( */}
            <Tooltip title="delete the program">
              {" "}
              <Box display="flex" alignItems="center" className="px-2 py-2">
                <DeleteIcon sx={{ color: "red" }} onClick={handleDeleteProg} />
              </Box>
            </Tooltip>
            {/* // )} */}
          </>
        );
      },
    },
    {
      field: "blocked",
      headerName: "",
      width: 150,
      renderCell: (params) => {
        const handleBlockingStatusChange = async (e) => {
          console.log(e.target.checked);
          setProgramlist((prev) =>
            prev.map((data) =>
              data.id === params.row.id
                ? { ...data, isAvailable: data.isAvailable }
                : data
            )
          );
          setConfirmationOpen(true);
          setChangeBlockStatusOfOrg({
            id: params.row.id,
            isAvailable: e.target.checked,
          });
        };
        return (
          <>
            {window.sessionStorage.getItem("user_role_type") === "admin" && (
              <Tooltip title="change status of block to unblock or vice-versa">
                {" "}
                <Box display="flex" alignItems="center" className="px-2">
                  <Typography>Available</Typography>
                  <Switch
                    sx={{
                      "& .MuiSwitch-track": {
                        // backgroundColor: isToggled ? "white" : "#ccc",
                        transition: "background-color 0.3s",
                        borderRadius: 20,
                      },
                      "& .MuiSwitch-thumb": {
                        width: 24,
                        height: 24,
                        backgroundColor: params.row.isAvailable
                          ? ThemeColor.PURPLE
                          : ThemeColor.BLACK,
                        transition: "transform 0.3s ease",
                        transform: params.row.isAvailable
                          ? "translateX(2px)"
                          : "translateX(0px)",
                      },
                      "& .MuiSwitch-switchBase": {
                        padding: 1,
                        transition: "transform 0.3s",
                        "&.Mui-checked + .MuiSwitch-track": {
                          backgroundColor: ThemeColor.LIGHTPURPLE,
                        },
                      },
                    }}
                    checked={params.row.isAvailable}
                    onChange={(e) => handleBlockingStatusChange(e)}
                    color="primary"
                  />
                </Box>
              </Tooltip>
            )}
          </>
        );
      },
    },
  ];

  const fields = [
    {
      label: "Degree",
      value: "degree",
      type: "multi-select",
      option: Degreelist,
    },
    ...(!id
      ? [
          {
            label: "University Name",
            value: "university",
            type: "multi-select",
            option: Universitylist,
          },
        ]
      : []),
    {
      label: "Program",
      value: "program",
      // type: "multi-select",
      // option:FilterProglist,
    },
    {
      label: "Country",
      value: "country",
      type: "multi-select",
      option: [
        {
          _id: "United States of America (USA)",
          title: "United States of America (USA)",
        },
        { _id: "Canada", title: "Canada" },
        {
          _id: "United Arab Emirates (UAE)",
          title: "United Arab Emirates (UAE)",
        },
        { _id: "Singapore", title: "Singapore" },
        {
          _id: "United Kingdom",
          title: "United Kingdom",
        },
      ],
    },
    {
      label: "State",
      value: "state",
      type: "multi-select",
      option: [
        { _id: "Alabama", title: "Alabama" },
        { _id: "Alaska", title: "Alaska" },
        { _id: "Arizona", title: "Arizona" },
        { _id: "Arkansas", title: "Arkansas" },
        { _id: "California", title: "California" },
        { _id: "Colorado", title: "Colorado" },
        { _id: "Connecticut", title: "Connecticut" },
        { _id: "Delaware", title: "Delaware" },
        { _id: "Florida", title: "Florida" },
        { _id: "Georgia", title: "Georgia" },
        { _id: "Hawaii", title: "Hawaii" },
        { _id: "Idaho", title: "Idaho" },
        { _id: "Illinois", title: "Illinois" },
        { _id: "Indiana", title: "Indiana" },
        { _id: "Iowa", title: "Iowa" },
        { _id: "Kansas", title: "Kansas" },
        { _id: "Kentucky", title: "Kentucky" },
        { _id: "Louisiana", title: "Louisiana" },
        { _id: "Maine", title: "Maine" },
        { _id: "Maryland", title: "Maryland" },
        { _id: "Massachusetts", title: "Massachusetts" },
        { _id: "Michigan", title: "Michigan" },
        { _id: "Minnesota", title: "Minnesota" },
        { _id: "Mississippi", title: "Mississippi" },
        { _id: "Missouri", title: "Missouri" },
        { _id: "Montana", title: "Montana" },
        { _id: "Nebraska", title: "Nebraska" },
        { _id: "Nevada", title: "Nevada" },
        { _id: "New Hampshire", title: "New Hampshire" },
        { _id: "New Jersey", title: "New Jersey" },
        { _id: "New Mexico", title: "New Mexico" },
        { _id: "New York", title: "New York" },
        {
          _id: "North Carolina",
          title: "North Carolina",
        },
        { _id: "North Dakota", title: "North Dakota" },
        { _id: "Ohio", title: "Ohio" },
        { _id: "Oklahoma", title: "Oklahoma" },
        { _id: "Oregon", title: "Oregon" },
        { _id: "Pennsylvania", title: "Pennsylvania" },
        { _id: "Rhode Island", title: "Rhode Island" },
        {
          _id: "South Carolina",
          title: "South Carolina",
        },
        { _id: "South Dakota", title: "South Dakota" },
        { _id: "Tennessee", title: "Tennessee" },
        { _id: "Texas", title: "Texas" },
        { _id: "Utah", title: "Utah" },
        { _id: "Vermont", title: "Vermont" },
        { _id: "Virginia", title: "Virginia" },
        { _id: "Washington", title: "Washington" },
        { _id: "West Virginia", title: "West Virginia" },
        { _id: "Wisconsin", title: "Wisconsin" },
        { _id: "Wyoming", title: "Wyoming" },
      ],
    },
    { label: "City", value: "city", type: "text" },
    {
      label: "Contract Type",
      value: "contractType",
      type: "multi-select",
      option: [
        { _id: "Direct", title: "Direct" },
        { _id: "Kaplan", title: "Kaplan" },
        { _id: "EAG", title: "EAG" },
        { _id: "EduCo.", title: "EduCo." },
        { _id: "Shorelight", title: "Shorelight" },
      ],
    },
  ];

  //(ProgramlistState, "catalog data");

  useEffect(() => {
    setTable_load(true);
    if (id) reload(id);
    else reload();
  }, [id]);

  useEffect(() => {
    // Rows for a filtered view do not come from redux. Letting this run
    // would write the stale unfiltered list back over them - which is why
    // the filter survived a reload (redux is empty then) but not a Back.
    //
    // A later redux change means an action elsewhere refreshed the data
    // (a modal, an import), so the filtered view is fetched again instead.
    if (getFilters().length > 0) {
      if (reduxSyncedOnce.current) fetchData(getFilters());
      reduxSyncedOnce.current = true;
      return;
    }
    reduxSyncedOnce.current = true;
    const updatedData = ProgramlistState?.map(({ _id, ...rest }) => ({
      id: _id,
      // title: program,
      ...rest,
    }));
    setProgramlist(updatedData);
    setTable_load(false);
  }, [ProgramlistState]);

  return (
    <>
      <Grid container spacing={2}>
        <Grid item lg={8} md={7} xs={12}>
          <div className="d-flex align-items-center">
          <IconButton onClick={() => navigate(-1)}>
              <ArrowBackIcon />
            </IconButton>
            <Typography
              fontFamily={FontFamily.Poppins}
              fontWeight={fontWeight.W600}
              fontSize={fontSize.h2.small}
            >
              State List
            </Typography>
          </div>
        </Grid>
        <Grid item lg={4} md={5} xs={12}>
          <Box
            className="d-flex align-items-center w-100"
            sx={{
              justifyContent: {
                sm: "space-between",
                xs: "space-between",
                lg: "end",
                md: "end",
              },
            }}
          >
            <OutlineCustomButton
              variant="contained"
              type="submit"
              backgroundColor={ThemeColor.PURPLE}
              onClick={() => setFilterOpen(true)}
            >
              Filter
            </OutlineCustomButton>
            
          </Box>
        </Grid>
      </Grid>

      <FilterComponent
        open={isFilterOpen}
        onClose={() => setFilterOpen(false)}
        onApply={handleApplyFilters}
            initialFilters={activeFilters}
        fields={fields}
      />
      <div className="table-container mt-4" style={{ overflowX: "hidden" }}>
        <CustomDataTable
          row={Programlist ? Programlist : []}
          columns={columns}
          loading={table_load}
          getRowClassName={(params) =>
            params.row.isAvailable ? "row-white" : "row-dull"
          }
        />
      </div>
      <ConfirmationModal
        msg="Updated"
        btnName="Update"
        handleConfirmationClose={() => {
          setProgramlist((prev) =>
            prev.map((data) =>
              data.id === changeBlockStatusOfOrg.id
                ? {
                    ...data,
                    isAvailable: changeBlockStatusOfOrg.isAvailable,
                  }
                : data
            )
          );
          setConfirmationOpen(false);
        }}
        deletefunction={async () => {
          try {
            const res = await EditProgAvailableService(
              changeBlockStatusOfOrg.isAvailable,
              changeBlockStatusOfOrg.id
            );

            if (res.status === 200) {
              reload(id);
              setIsToggled(!isToggled); // Dispatch the action if success
              return res; // Return the result so the child can access it
            } else {
              return Promise.reject("Unexpected response status"); // Handle unexpected status codes
            }
          } catch (e) {
            dispatch(
              showSnackbar(
                e.response?.data?.message || "Error occurred",
                "error"
              )
            );
            return e;
          }
        }}
        confirmationopen={confirmationopen}
        message={"Want to change the blocking status?"}
      />

      {/* for delete */}
      <ConfirmationModal
        msg="Delete"
        btnName="Delete"
        handleConfirmationClose={() => {
          setDeleteConfirmationOpen(false);
        }}
        deletefunction={async () => {
          try {
            const res = await DeleteProgAvailableService(deleteId);

            if (res.status === 200) {
              reload(id);
              // setIsToggled(!isToggled); // Dispatch the action if success
              return res; // Return the result so the child can access it
            } else {
              return Promise.reject("Unexpected response status"); // Handle unexpected status codes
            }
          } catch (e) {
            dispatch(
              showSnackbar(
                e.response?.data?.message || "Error occurred",
                "error"
              )
            );
            return e;
          }
        }}
        confirmationopen={deleteconfirmationopen}
        message={"Want to delete the program?"}
      />
    </>
  );
};

function Statelist() {
  return (
    <div>
      <ResponsiveDrawer maincontent={<ProgramlistPage />} />
    </div>
  );
}

export default Statelist;
